<template>
  <button
    aria-haspopup="dialog"
    aria-label="Order Free Swatches"
    class="order-swatches-button"
    :class="isMcom ? 'link-med' : 'link-sm'"
    @click.stop="openSwatchesDrawer"
  >
    {{ orderSwatchesText }}
  </button>
</template>

<script setup>
import { defineAsyncComponent, markRaw, onMounted } from 'vue';
import { useColor } from '@common-vue/media-card-large/src/modules/color';
import { useType as useOrientation } from '@modules/types';
import { useBrand } from '@composables/useBrand';
import { useSlideout } from '@composables/utils/useSlideout';
import { useProduct } from '@modules/product';
import { useFeatureEligibility } from '@modules/featureControl';
import { useProductPrice } from '@modules/price/composables';
import { tagOrderSwatchesPresent } from '../../../features/analytics/orderSwatches';

const { isMcom } = useBrand();
const { orderSwatches } = useFeatureEligibility();
const { showSlideout } = useSlideout();
const { productId } = useProduct();
const { colors } = useColor(productId);
const orderSwatchesText = isMcom ? 'Order Free Swatches' : 'Order Swatches';
const selectedPrice = useProductPrice();
const { selectedTypeId: selectedOrientationId } = useOrientation(productId);

const openSwatchesDrawer = () => {
  showSlideout({
    id: 'Order Swatches',
    title: 'Order free swatches',
    component: markRaw(defineAsyncComponent(() => import(/* webpackChunkName: "OrderSwatchesInfo" */ './slideoutContent/OrderSwatchesInfo'))),
    props: {
      colors,
      selectedPrice,
      selectedOrientationId,
    },
  });
};

onMounted(() => {
  if (orderSwatches) {
    tagOrderSwatchesPresent(productId, selectedPrice.value);
  }
});

</script>

<style lang="scss" brand="mcom" scoped>
.order-swatches-button {
    color: $dashboard-color;
}
</style>
